import { watch, type Ref } from 'vue'

/**
 * Реализует автозакрытие элемента при клике вне элемента
 *
 * @param {vueRef} el - ссылка на элемент
 * @param {vueRef} state - реактивная переменная отвечающая за отображение элемента
 *
 */
export default (
	el: Ref<null | HTMLElement>,
	state: Ref<boolean>,
	action: (() => void) | null = null
) => {
	const close = (event: MouseEvent) => {
		if (el.value && !el.value.contains(event.target as Node)) {
			if (action) {
				action()
			} else {
				state.value = false
			}
		}
	}

	const setListner = () => document.addEventListener('click', close)
	const removeListner = () => document.removeEventListener('click', close)

	watch(state, (next, prev) => {
		if (next && !prev) {
			setTimeout(setListner, 0)
		} else if (!next && prev) {
			setTimeout(removeListner, 0)
		}
	})
}
